<template>
<div class="k-page-content">
	<el-tabs v-model="activeName" class="box-eltab">
		<el-tab-pane label="结案/反结案管理" name="first">
			<div class="k-page-common">
				<div class="k-common-header">
					<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
						<el-form :inline="true" :model="searchForm" size="mini">
							<el-form-item label="项目名称">
								<el-input v-model="searchForm.project_name" placeholder="请填写项目名称" clearable></el-input>
							</el-form-item>
							<el-form-item label="类型">
							    <el-select v-model="searchForm.type" placeholder="请选择" style="width: 100%;" clearable>
							        <el-option
							          label="结案"
							          value="1">
							        </el-option>
									<el-option
									  label="反结案"
									  value="2">
									</el-option>
							      </el-select>
							</el-form-item>
							<el-form-item label="申请日期">
								<el-date-picker
									clearable
									align="center"
									v-model="searchForm.create_time"
									type="daterange"
									value-format="yyyy-MM-dd"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
								  ></el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="doSearch">查询</el-button>
								<el-button type="primary" @click="reset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="k-common-con">
					<div class="k-table-wrapper">
						<div class="k-table-toolbar" style="margin-top:0;" v-if="$parent.$parent.isAuthAction('admin/customers/customer/solverprojectadd')">
							<div>
								<el-button size="mini" type="primary" @click="openSolve()">申请结案/反结案</el-button>
							</div>
						</div>
						<div class="k-table-con radio">
							<el-table
								:data="tableData.data"
								style="width: 100%"
								border
								stripe
								ref="table"
								highlight-current-row
								v-loading="loading"
								@sort-change="sortChange"
								:height="tableHeight">
							<el-table-column
									fixed
									prop="id"
									label="ID"
									width="50">
							</el-table-column>
							<el-table-column
									fixed
									prop="project_name"
									label="关联项目"
									min-width="150">
									<template slot-scope="scope">
										<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false" @click="detail(scope.row)" target="_blank">{{scope.row.project_name}}</el-link>
									</template>
							</el-table-column>
							<el-table-column
									fixed
									prop="type_txt"
									label="结案类型"
									width="80">
							</el-table-column>
							<el-table-column
									prop="project_code"
									label="关联项目编码"
									min-width="170">
							</el-table-column>
							<el-table-column
									prop="reason"
									label="理由"
									min-width="180">
							</el-table-column>
							<el-table-column
									prop="create_time"
									label="创建时间"
									width="160"
									sortable="custom">
							</el-table-column>
							<el-table-column
									prop="update_time"
									label="修改时间"
									width="160"
									sortable="custom">
							</el-table-column>
							<el-table-column
									fixed="right"
									align="center"
									prop="status_txt"
									label="状态"
									width="80">
							</el-table-column>
							<el-table-column
									fixed="right"
									label="操作"
									v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitsolproject') || $parent.$parent.isAuthAction('admin/customers/customer/deletesolve')"
									width="140">
								<template slot-scope="scope">
									<template v-if="scope.row.status==1">
										<el-button @click="handleTableFlow(scope.row)" type="text" :size="size" v-if="$parent.$parent.isAuthAction('admin/customers/customer/submitsolproject')">提交审批</el-button>
										<el-button type="text" @click="handleTableDelete(scope.row)" :size="size" v-if="$parent.$parent.isAuthAction('admin/customers/customer/deletesolve')">删除申请</el-button>
									</template>
									<template v-else>
										<el-button disabled type="text" :size="size">提交审批</el-button>
										<el-button disabled type="text"  :size="size">删除申请</el-button>
									</template>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination
							background
							ref="pagination"
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableData.page | number"
							:page-size="tableData.pagesize | number"
							:page-sizes="[15, 30, 50, 100]"
							layout="prev, pager, next, sizes, total"
							:total="tableData.total | number">
						</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</el-tab-pane>
	</el-tabs>
	<el-dialog
	  title="申请结案/反结案"
	  :visible.sync="addVisible"
	  v-loading="loading"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  width="50%">
	  <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
	  	<div>
	  		<el-form-item label="类型" prop="type">
	  			<el-radio-group v-model="addForm.type" @change="getProjectIdOptions()">
	  				<el-radio :label="1">结案</el-radio>
	  				<el-radio :label="2">反结案</el-radio>
	  			</el-radio-group>
	  		</el-form-item>
			<el-form-item label="项目" prop="project_id">
			  <el-select v-model="addForm.project_id" filterable remote placeholder="请输入您要搜索的项目名称" style="width: 100%;" clearable :remote-method="getProjectIdOptions">
			    <el-option
			      v-for="item in options.project_id_options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value"
			    ></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="理由" prop="remark">
				<el-input type="textarea" v-model="addForm.remark" placeholder="请输入理由" clearable maxlength="100" show-word-limit></el-input>
			</el-form-item>
	  	</div>
	  </el-form>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="addVisible = false" :size="size">取 消</el-button>
	    <el-button type="primary" @click="addsolve()" :size="size">确 定</el-button>
	  </span>
	</el-dialog>
</div>
</template>
<script>
export default {
  data() {
      return {
		  activeName: 'first',
		  size:'mini',
		  loading:true,
		  addVisible:false,
		  options: {
			project_id_options:[]
		  },
		  searchForm: {
			  project_name: '',
			  type:'',
			  create_time:''
		  },
		  resetSearch:{
			  project_name: '',
			  type:'',
			  create_time:''
		  },
		  addForm:{
				type:'',
				project_id:'',
				remark:''
		  },
		  rules: {
			addForm: {
				'type': [
					{required: true, message: '请选择类型', trigger: ['change', 'blur']}
				],
				'project_id': [
					{required: true, message: '请选择项目', trigger: ['change', 'blur']}
				],
				'remark': [
					{required: true, message: '请填写理由', trigger: ['change', 'blur']}
				],
			},
		  },
		  tableData: {
			  total: 0,
			  pagesize: 15,
			  page: 1,
			  data: []
		  },
	  }
	},
	computed: {
		tableHeight: function () {
		  return window.innerHeight - 320;
		},
	},
	mounted: function () {
		//this.handleSearch(this.searchForm)
	},
	methods: {
		handleSizeChange(pages){
				this.tableData.pagesize = pages
				this.handleSearch(this.searchForm, 1);
		},
		//列表
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/solvelist',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
				   this.$nextTick(() => {
					 if (this.$refs.table) {
					   this.$refs.table.doLayout();
					 }
				   });
			   }else{
				   this.$message.error(res.msg);
			   }
			   this.loading = false;
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
		  this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
		  this.doSearch(); 
		},
		// 排序
		sortChange(e) {
		  var order;
		  var prop = e.prop;
		  if (e.order == 'ascending') {
			  order = 'asc';
		  } else if (e.order == 'descending') {
			  order = 'desc';
		  } else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
		  }
		  this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
		  this.handleSearch(this.searchForm, val);
		},
		openSolve(){
			this.addForm={
				type:'',
				project_id:'',
				remark:''
		    }
			this.$nextTick(() => {
			  this.$refs['addForm'].clearValidate();
			});
			this.addVisible = true
		},
		addsolve(){
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/customers/customer/solverprojectadd',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.$message({
							  showClose: true,
							  message: '添加成功！',
							  type: 'success'
						  });
						  this.handleSearch(this.searchForm)
						  this.addVisible = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
				}
			}.bind(this));
		},
		//获取项目下拉列表
		getProjectIdOptions(query){
			query = query ? query : ''
			this.addForm.project_id = ''
			this.$nextTick(() => {
			  this.$refs['addForm'].clearValidate();
			});
			this.$api.get('/admin/customers/customer/projectdwlist',{type:this.addForm.type,'query':query}).then(res => {
			  if (res.code === 0) {
				  this.options.project_id_options = res.data
			  }
			})
		},
		//提交审批
		handleTableFlow(row){
			this.loading = true;
			this.$api.post('/admin/customers/customer/submitsolproject',{id:row.id}).then(res => {
				  if (res.code === 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (row.id == item.id) {
							  this.$set(data[index], 'status_txt', '待审核');
							  this.$set(data[index], 'status', 2);
						  }
					  }.bind(this));		
					  this.$message({
						  showClose: true,
						  message: '该申请已进入审批流程，等待审核！',
						  type: 'success'
					  });	
				  } else {
					this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		// 删除申请
		handleTableDelete(row) {
		  this.$confirm('此操作将永久删除该申请, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/customers/customer/deletesolve', {id:row.id}).then(res => {
				  if (res.code === 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该申请已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		},
		//打开详情页
		detail(row){
			this.$router.push({
			  name: 'SolveDetail',
			  query:{ id: row.id, set_id:14, type:'detail' }
			});
		}
	},
	beforeRouteEnter(to, from, next) {
	    next(vm => {
	      if (from.path != '/solveDetail') {
			vm.reset()
	      }
	    });
	}
}
</script>
<style lang="scss" scoped>
.select {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .form {
    padding-top: 100px;
    width: 500px;
  }
}
.resource_name{
	.el-form-item__content{
		display: flex;
		align-items: center;
		img{
			width: 14px;
			height: 14px;
			margin-right: 4px;
		}
		span{
			color:#409EFF;
		}
	}
}
</style>